import { Button, Space, Alert, Typography } from 'antd';
import React, { useState } from 'react';
import { get } from 'lodash';
import { PlusOutlined } from '@ant-design/icons';
import { ManageFooter, StyledDrawer, StyledCheckboxGroup, WarningText } from './styled';
import { FlexFill } from '../../common/Utils/Layout';
import { useWidgetControl } from '../state/useWidgetControl';
import { EmptyPlaceholder } from '@src/components/common';
import apptracker from '@src/utils/sensor/apptracker';
import { ADD_WIDGET } from '@src/utils/sensor/track';
import { GLOBAL_MAX_WIDGETS_ALLOWED } from '../config/constants';
import { selectedWidgetsAtom } from '../state/atoms';
import { useAtom } from 'jotai';
import { getAddedWidgetsLength } from '../state/dashboard';
import DrawerCard from './DrawerCard';
const { Text } = Typography;

const trackWidgets = (selected, availableWidgets) => {
  const widgets = [];
  for (const [type, count] of Object.entries(selected)) {
    const widgetData = availableWidgets.find((ele) => ele.type === type);
    for (let i = 0; i < count; i++) {
      const title = get(widgetData, ['meta', 'title'], 'undefined');
      widgets.push(title);
    }
  }
  apptracker(ADD_WIDGET, {
    widgets: widgets,
  });
};

function WidgetControl() {
  const addedWidgetsLength = getAddedWidgetsLength();
  const [selected, setSelected] = useAtom(selectedWidgetsAtom);

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setSelected({ widgets: {}, totalCount: 0 }); // reset state
  };

  const onClear = () => {
    setSelected({ widgets: {}, totalCount: 0 });
  };

  // TODO: preset/context based filtering on widgets

  const { availableWidgets, addWidgets } = useWidgetControl();

  const applyWidgets = () => {
    addWidgets(selected.widgets);
    trackWidgets(selected.widgets, availableWidgets);
    onClose();
  };

  const renderDrawerTitle = () => {
    const count = addedWidgetsLength + selected.totalCount;
    return (
      <span>
        Widgets -{' '}
        <Text
          type={addedWidgetsLength >= GLOBAL_MAX_WIDGETS_ALLOWED ? 'warning' : undefined}
          className="ant-drawer-title"
        >
          {' '}
          {count}/{GLOBAL_MAX_WIDGETS_ALLOWED} Added{' '}
        </Text>
      </span>
    );
  };

  const footer = (
    <ManageFooter>
      <Button onClick={onClear} disabled={selected.totalCount === 0}>
        Clear All
      </Button>
      <FlexFill />
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={applyWidgets}
        type="primary"
        disabled={
          selected.totalCount === 0 ||
          addedWidgetsLength + selected.totalCount > GLOBAL_MAX_WIDGETS_ALLOWED ||
          addedWidgetsLength >= GLOBAL_MAX_WIDGETS_ALLOWED
        }
      >
        Apply
      </Button>
    </ManageFooter>
  );

  const DrawerContent =
    availableWidgets.length === 0 ? (
      <EmptyPlaceholder className="" emptyPlaceholder="No widgets available" />
    ) : (
      <>
        {addedWidgetsLength >= GLOBAL_MAX_WIDGETS_ALLOWED && (
          <>
            <WarningText>
              <Alert
                message={`Please remove some existing widgets before adding new ones.`}
                banner
              />
            </WarningText>
          </>
        )}

        <StyledCheckboxGroup>
          {availableWidgets.map((opt) => (
            <DrawerCard key={opt.type} data={opt} addedWidgetsLength={addedWidgetsLength} />
          ))}
        </StyledCheckboxGroup>
      </>
    );

  return (
    <>
      <Space>
        <Button onClick={handleClick} icon={<PlusOutlined />}>
          Widgets
        </Button>
      </Space>
      <StyledDrawer
        title={renderDrawerTitle()}
        placement="right"
        size="large"
        onClose={onClose}
        open={open}
        footer={footer}
        destroyOnHidden={true}
      >
        <div>{DrawerContent}</div>
      </StyledDrawer>
    </>
  );
}

export default WidgetControl;
